/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
// import moment from "moment";
// import tableStyle from "../../../../theme/styles/table";
// import { PERMISSIONS } from "../../../../contants";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "./styles";
import Table from "./Table";
// import NewTable from "../../../member/components/Newtable/NewTable";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "20rem",
  },
};
const FRIEND_SEAECH_TABLE_COL = [
  {
    displayName: "S.No",
    key: "s.no",
  },
  {
    displayName: "Structure Name",
    key: "strucutreName",
  },
  {
    displayName: "MD",
    key: "mdCount",
  },
  {
    displayName: "WD",
    key: "wdCount",
  },
  {
    displayName: "YMD",
    key: "ymdCount",
  },
  {
    displayName: "YWD",
    key: "ywdCount",
  },
  {
    displayName: "FDB",
    key: "fdbCount",
  },
  {
    displayName: "FDG",
    key: "fdgCount",
  },
  {
    displayName: "Total",
    key: "total",
  },
  {
    displayName: "Others",
    key: "others",
  },
  {
    displayName: "New Friend",
    key: "newFriend",
  },
  {
    displayName: "Friend",
    key: "friend",
  },
];

const getRows = ({
  searchData,
  //   currentPage,
  //   pageSize,
  // initialAdvanceFormValue,
  //   onSelectMember,
  //   onSelectMemberForTransfer,
  //   hasPermission,
  // showStatusColumn,
  // onMemberStatusToggle,
  //   startDate,
  //   EndDate,
}) => {
  const divisionCountsMap = {};
  const rows = [];

  searchData.forEach(
    ({
      structureId,
      // structureName,
      memberStats,
      friendCount,
      newFriendCount,
      otherCount,
    }) => {
      // Old behavior (bug): using structureName as the key breaks when multiple rows have
      // the same structureName (e.g., multiple "Block 1" with different structureId).
      // Keeping this for future reference.
      //
      // const mapKey = structureName;

      const mapKey = structureId;

      if (!divisionCountsMap[mapKey]) {
        divisionCountsMap[mapKey] = {
          WD: 0,
          MD: 0,
          YWD: 0,
          YMD: 0,
          "FD(G)": 0,
          "FD(B)": 0,
          newFriends: newFriendCount || 0,
          friends: friendCount || 0,
          others: otherCount || 0,
          total: 0,
        };
      }

      memberStats?.forEach(({ divisionName, memberCount }) => {
        divisionCountsMap[mapKey][divisionName] = memberCount;
        divisionCountsMap[mapKey].total += memberCount;
      });
    }
  );

  const grandTotal = {
    WD: 0,
    MD: 0,
    YWD: 0,
    YMD: 0,
    "FD(G)": 0,
    "FD(B)": 0,
    newFriends: 0,
    friends: 0,
    others: 0,
    total: 0,
  };

  searchData.map((attendanceInfo, index) => {
    const { structureId, structureName } = attendanceInfo;
    const {
      WD,
      MD,
      YWD,
      YMD,
      "FD(G)": fdgCount,
      "FD(B)": fdbCount,
      newFriends,
      friends,
      others,
      total,
    } = divisionCountsMap[structureId];

    grandTotal.WD += WD;
    grandTotal.MD += MD;
    grandTotal.YWD += YWD;
    grandTotal.YMD += YMD;
    grandTotal["FD(G)"] += fdgCount;
    grandTotal["FD(B)"] += fdbCount;
    grandTotal.newFriends += newFriends;
    grandTotal.friends += friends;
    grandTotal.others += others;
    grandTotal.total += total;

    rows.push(
      <TableRow key={structureId ?? `${structureName}-${index}`}>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {index + 1}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {attendanceInfo?.structureName || "NA"}
          </Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography
            style={{ ...styles.typoghrphyStyle, textAlign: "center" }}
          >
            {MD}
          </Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{WD}</Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{YMD}</Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{YWD}</Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{fdbCount}</Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{fdgCount}</Typography>{" "}
        </TableCell>

        <TableCell
          style={{
            ...tabelCellWidth.medium,
            width: "7rem",
            textAlign: "center",
          }}
        >
          <div style={styles.tableBox}>
            <Typography
              style={{
                ...styles.typoghrphyStyle,
                fontWeight: 600,
              }}
            >
              {total}
            </Typography>
          </div>
        </TableCell>

        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{others} </Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{newFriends}</Typography>{" "}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
          <Typography style={styles.typoghrphyStyle}>{friends} </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <div
            style={{
              ...tabelCellWidth.medium,
              textAlign: "center",
              width: "5rem",
            }}
          >
            <Typography style={{ ...styles.typoghrphyStyle, fontWeight: 600 }}>
              {divisionCountsMap[structureId].total +
                newFriends +
                others +
                friends}
            </Typography>
          </div>
        </TableCell>
      </TableRow>
    );
  });

  rows.push(
    <TableRow
      style={{
        // ...tableStyle.tableRow,
        height: "60px",
        backgroundColor: "#BAD9EC",
      }}
    >
      <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>Grand Total</Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>{grandTotal.MD}</Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>{grandTotal.WD}</Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>{grandTotal.YMD}</Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>{grandTotal.YWD}</Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal["FD(B)"]}
        </Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal["FD(G)"]}
        </Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.medium, textAlign: "center" }}>
        <div style={styles.tableBox}>
          <Typography style={{ ...styles.typoghrphyStyle, fontWeight: 600 }}>
            {grandTotal.total}
          </Typography>
        </div>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal.others}
        </Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal.newFriends}
        </Typography>
      </TableCell>
      <TableCell style={{ ...tabelCellWidth.tiny, textAlign: "center" }}>
        <Typography style={styles.typoghrphyStyle}>
          {grandTotal.friends}
        </Typography>
      </TableCell>
      <TableCell style={tabelCellWidth.medium}>
        <div
          style={{
            ...tabelCellWidth.medium,
            textAlign: "center",
            width: "5rem",
          }}
        >
          <Typography style={{ ...styles.typoghrphyStyle, fontWeight: 600 }}>
            {grandTotal.total +
              grandTotal.newFriends +
              grandTotal.others +
              grandTotal.friends}
          </Typography>
        </div>
      </TableCell>
    </TableRow>
  );

  return rows;
};

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  initialAdvanceFormValue,
  appliedFilters,
}) {
  const [tableColumns, setTableColumns] = useState([]);
  useEffect(() => {
    // Update table columns when the searchData changes
    const updatedColumns = [...FRIEND_SEAECH_TABLE_COL];

    if (searchData.length > 0) {
      const { monthsData } = searchData[0];
      if (monthsData && monthsData.length > 0) {
        monthsData.forEach((monthInfo) => {
          const { monthName } = monthInfo;
          const monthKey = monthName.toLowerCase();

          if (!updatedColumns.some((col) => col.key === monthKey)) {
            updatedColumns.push({
              displayName: monthName,
              key: monthKey,
            });
          }
        });
      }
    }
    updatedColumns.push({
      displayName: "Grand Total",
      key: "grandTotal",
    });

    setTableColumns(updatedColumns);
  }, [searchData]);
  // const { monthsData } = searchData[0];
  // if (monthsData && monthsData.length > 0) {
  //   monthsData.forEach((monthInfo) => {
  //     const { monthName } = monthInfo;
  //     const monthKey = monthName.toLowerCase();

  //     if (!FRIEND_SEAECH_TABLE_COL.some((col) => col.key === monthKey)) {
  //       FRIEND_SEAECH_TABLE_COL.push({
  //         displayName: monthName,
  //         key: monthKey,
  //       });
  //     }
  //   });
  // }
  const columns = tableColumns;
  // const columns = showStatusColumn
  //   ? FRIEND_SEAECH_TABLE_COL
  //   : FRIEND_SEAECH_TABLE_COL.filter(
  //       (c) => c.key !== "mobile" && c.key !== "address"
  //     );

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          initialAdvanceFormValue,
          appliedFilters,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
